module.exports = __webpack_public_path__ + "media/leather_2.ffa6c47c.webm";